// recoSuggestions.js
// Suggestions de recommandation figées, basées sur les recommandations les plus
// fréquentes de l'historique du carnet (toutes années confondues : 2020–2024).
// NB : le champ remarque n'a quasiment pas été utilisé en 2025 — les fréquences
// reflètent l'historique complet, pas une année précise.
//
// Indexé par unit.unitName (chaîne arabe stable telle qu'elle arrive du payload API).
// Clé "_comportement" : zone "Comportement et assiduité" (ReportCard.remarque).
//
// Chaque entrée : { text, freq }. Les fréquences sont indicatives (certaines
// phrases ont été nettoyées : casse anglaise, anonymisation prépa, fusion de
// doublons orthographiques), donc à considérer comme ordre de grandeur.
//
// V1 figée. À affiner ultérieurement (favoris, gestion par l'école, etc.).

const recoSuggestions = {
  // ───────── Modules classes normales ─────────

  "مجال اللغة الانجليزية": [
    { text: "Excellent results", freq: 281 },
    { text: "Can do better", freq: 157 },
    { text: "Good results", freq: 111 },
    { text: "Quite good results", freq: 103 },
    { text: "Very good results", freq: 71 },
    { text: "Should work harder", freq: 26 },
    { text: "Quite good", freq: 23 },
    { text: "Excellent pupil", freq: 18 },
    { text: "You can do better", freq: 18 },
    { text: "You should work harder", freq: 18 },
  ],

  "مجال العلوم و التكنولوجيا": [
    { text: "نتائج متميزة", freq: 6 },
    { text: "حسن جدا", freq: 5 },
    { text: "نتيجة الرياضيات قابلة للتحسن", freq: 5 },
    { text: "عليك أن تتحلّي بمزيد من الثّقة في نفسك.أشجّعك", freq: 5 },
    { text: "عليك أن تتحلّى بمزيد من الثّقة في نفسك.أشجّعك", freq: 4 },
    { text: "قادرة على ماهو أفضل أشجّعك", freq: 5 },
    { text: "قادر على ماهو أفضل أشجّعك", freq: 4 },
    { text: "عمل ممتاز أشجعك", freq: 5 },
    { text: "أدعوه الى مزيد التدرب على طرح سؤال ذي مرحلتين", freq: 4 },
    { text: "أحسنت واصل", freq: 3 },
  ],

  "مجال التنشئة": [
    { text: "نتائج متميزة", freq: 19 },
    { text: "عليه بالاستذكار", freq: 13 },
    { text: "نتائج طيبة", freq: 9 },
    { text: "نتائج حسنة", freq: 8 },
    { text: "عليها بالاستذكار", freq: 7 },
    { text: "نتائج ممتازة أحسنت", freq: 6 },
    { text: "نتائج ممتازة واصل", freq: 5 },
    { text: "نتائج حسنة واصلي", freq: 5 },
    { text: "أشكره و أدعوه لمزيد التميز", freq: 4 },
    { text: "حققت الكفاية بتميز", freq: 4 },
  ],

  "مجال اللغة العربية": [
    { text: "أدعوه الى المطالعة لاثراء زاده اللغوي", freq: 11 },
    { text: "نتائج متميزة", freq: 10 },
    { text: "أدعوها الى المطالعة لاثراء زادها اللغوي", freq: 5 },
    { text: "نتائج دون المأمول", freq: 5 },
    { text: "نتائج قابلة للتحسن", freq: 4 },
    { text: "نتائج متميزة فلتواصل", freq: 4 },
    { text: "نتائج جيدة", freq: 4 },
    { text: "نتائج متميزة فلتواصلي", freq: 3 },
    { text: "نتائج طيبة يمكنك تدعيمها", freq: 2 },
    { text: "قادرة على الأفضل", freq: 2 },
  ],

  "مجال اللغة الفرنسية": [
    { text: "Peut mieux faire.", freq: 6 },
    { text: "Résultats satisfaisants dans l'ensemble.", freq: 6 },
    { text: "Peut mieux faire. Doit travailler davantage la dictée !", freq: 5 },
    { text: "Bonne continuation", freq: 4 },
    { text: "Bon travail. Tu peux mieux faire.", freq: 3 },
    { text: "Excellents résultats. Élève sérieux et appliqué.", freq: 3 },
    { text: "Elle peut mieux faire.", freq: 3 },
    { text: "Bon travail", freq: 3 },
    { text: "Très bon travail. Continue comme ça !", freq: 1 },
  ],

  // ───────── Modules classes prépa ─────────

  "مجال العربية": [
    { text: "يسعى الى إنجاز المطلوب بإتقان", freq: 7 },
    { text: "تسعى الى إنجاز المطلوب بإتقان", freq: 7 },
    { text: "تلميذة ممتازة عملا و سلوكا", freq: 3 },
    { text: "أثمن مجهودها وأدعوها لمزيد التفوق", freq: 3 },
    { text: "تلميذة ممتازة عملا و سلوكا أشجعها و أدعوها لمزيد التوفق", freq: 2 },
    { text: "نتائج مشرفة أثمن مجهوده و أدعوه لمزيد التميز", freq: 2 },
    { text: "نتائج طيبة يمكنك تدعيمها", freq: 2 },
    { text: "نتائج مشرفة أشكره على مجهوداته", freq: 2 },
  ],

  // Français prépa (anonymisé : [Prénom] retiré)
  "مجال الفرنسية": [
    { text: "Doit s'appliquer davantage.", freq: 4 },
    { text: "Doit être plus attentif en classe.", freq: 3 },
    { text: "Bon élève, je l'encourage.", freq: 2 },
    { text: "Bravo, continue !", freq: 2 },
  ],

  "مجال الانشطة": [
    { text: "له رغبة واضحة في الإقبال على ممارسة أنشطة التفكير", freq: 10 },
    { text: "عملها مشرف و نتائجها مثمرة", freq: 9 },
    { text: "له قدرات محترمة في القيام بالعمل المنظم", freq: 8 },
    { text: "أشكره على مجهوده و أدعوه الى المزيد من التقدم", freq: 5 },
    { text: "عمله مشرف و نتائجه مثمرة", freq: 5 },
    { text: "لها رغبة واضحة في الإقبال على ممارسة الأنشطة أشكرها", freq: 4 },
    { text: "أشكرها على مجهودها و أدعوها الى مزيد التميز", freq: 4 },
    { text: "لها قدرات محترمة في القيام بالعمل المنظم", freq: 4 },
    { text: "تتميز بالحيوية و النشاط و تتوق مزيد التحسن اشكرها", freq: 3 },
    { text: "تتميز بإحكام التواصل مع أفراد المجموعة و تقبل على العمل التعاوني", freq: 3 },
  ],

  // ───────── Zone "Comportement et assiduité" (ReportCard.remarque) ─────────
  "_comportement": [
    { text: "شهادة شكر", freq: 13 },
    { text: "شهادة شرف", freq: 9 },
    { text: "شهادة رضا", freq: 8 },
    { text: "شهادة تشجيع", freq: 8 },
    { text: "حسن السلوك و المواظبة", freq: 6 },
    { text: "ترتقي", freq: 5 },
    { text: "تلميذة منضبطة", freq: 4 },
    { text: "تلميذ منضبط", freq: 4 },
    { text: "تلميذ ممتاز عملا و سلوكا", freq: 4 },
    { text: "تلميذة ممتازة عملا و سلوكا", freq: 4 },
  ],
};

export default recoSuggestions;
